import React from "react";
import {cx} from "../../../lib/ClassSet";
import "./ProductItem.css";

const ProductItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "shop-product-list-item": true,
    "u-selected": props.selected,
    "u-deleted": data.get("productTitle") === "-deleted-"
  })

  let pricing = data.get("pricing").map(x => {
    return (
      <span key={x.get("currency")} className="field f-pricing-item">
        <span className="currency">{x.get("currency")}</span>
        <span className="value">{x.get("value")}</span>
      </span>
    )
  })
  let pendingPricing = data.get("pendingPricing").map(x => {
    return (
      <span key={x.get("currency")} className="field f-pricing-item f-pending-pricing-item" title="Pending price change">
        <span className="currency">{x.get("currency")}</span>
        <span className="value">{x.get("value")}</span>
      </span>
    )
  })

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-sku">{data.get("productSku")}</td>
      <td className="field f-title">{data.get("productTitle")}</td>
      <td className="field f-pricing">{pricing}{pendingPricing}</td>
    </tr>
  )
}

export default ProductItem;